import { createAction, props } from '@ngrx/store';
import {
	ClassificationVariables,
	IClassification,
} from '@app/pages/cmms/interfaces/classification.interfaces';
import { CMMSLayoutType } from '@app/pages/cmms/interfaces/layout.interfaces';
import { MaintenanceSelectionTypes } from '@app/pages/cmms/configs/cmms-maintenance.enums';

export const workOrdersOpened = createAction('[CMMS] Work orders table opened');

export const incidentsOpened = createAction('[CMMS] Incidents table opened');

export const requestOpened = createAction('[CMMS] Requests table opened');

export const fileOpened = createAction('[CMMS] Files table opened');

export const assetsOpened = createAction('[CMMS] Assets table opened');

export const messagesOpened = createAction('[CMMS] Messages table opened');

export const contactsOpened = createAction('[CMMS] Contacts table opened');

export const startClassificationLoad = createAction(
	'[CMMS] Start classification load',
	props<{ queryParams: Pick<ClassificationVariables, 'name' | 'type'> }>()
);

export const classificationLoadSuccess = createAction(
	'[CMMS] Classification load success',
	props<{ classifications: IClassification[] }>()
);

export const selectLayoutType = createAction(
	'[CMMS] Select layout type',
	props<{ layoutType: CMMSLayoutType }>()
);

export const startLoadNsFieldsKeyValues = createAction(
	'[CMMS] start loading ns fields key values'
);

export const loadedNsFieldsKeyValues = createAction(
	'[CMMS] loaded ns fields key values',
	props<{
		nsFieldsKeyValues: {
			[key in MaintenanceSelectionTypes]: {
				enumValues: { name: string; description: string }[];
				label: string;
			};
		};
		nameDescriptionList: { [name: string]: string };
	}>()
);

export const getLayoutOptions = createAction(
	'[CMMS] get layout options',
	props<{ disableCalendar: boolean }>()
);
